export default "__VITE_ASSET__F5NZYoZN__"